import CustomInput from "../components/common/customInput";
import { Button, Card, CardBody, Col, Form, Row } from "reactstrap";
import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from "../redux/actions/userActions";
import Breadcrumb from "../components/common/Breadcrumb";

const OrgRegister = () => {
    const dispatch = useDispatch();
    const schema = yup.object({
        email: yup.string().email().required('Email is required'),
        password: yup.string()
            .required('No password provided.')
            .min(6, 'Password is too short - should be 6 chars minimum.')
        // .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.')

    }).required()


    const { formState: { errors }, handleSubmit, control, register } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            role: "admin"
        }
    });
    const onSubmit = (data) => {
        dispatch(loginUser(data))
    };
    return (
        <div className="page-body">
            <div className="min-h-screen flex ">
                <div className="container">
                    <Breadcrumb title="Orginization Registeration" parent="Products" />
                    <Card className="bg-set">
                        <CardBody>
                            <Form className="form-horizontal auth-form">
                                <Row xl="2">
                                    <CustomInput
                                        fieldLabel="Name"
                                        fieldName={"name"}
                                        placeholder="Name"
                                        error={errors.name}
                                        control={control}
                                        type={"text"}
                                        classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                    <CustomInput
                                        fieldLabel="Email"
                                        fieldName={"Email"}
                                        placeholder="email"
                                        error={errors.email}
                                        control={control}
                                        type={"text"}
                                        classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                </Row>
                                <Row xl="2">
                                    <CustomInput
                                        fieldLabel="Website"
                                        fieldName={"Website"}
                                        placeholder="Website"
                                        error={errors.website}
                                        control={control}
                                        type={"text"}
                                        classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                    <CustomInput
                                        fieldLabel="Admin Email"
                                        fieldName={"email"}
                                        placeholder="Email"
                                        error={errors.email}
                                        control={control}
                                        type={"email"}
                                        classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                </Row>
                                <Row xl="2">
                                    <CustomInput
                                        fieldLabel="Admin Name"
                                        fieldName={"adminName"}
                                        placeholder="Admin Name"
                                        error={errors.adminName}
                                        control={control}
                                        type={"text"}
                                        classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                    <CustomInput
                                        fieldLabel="Admin Phone Number"
                                        fieldName={"adminPhoneNumber"}
                                        placeholder="Admin Phone Number"
                                        error={errors.adminPhoneNumber}
                                        control={control}
                                        type={"text"}
                                        classData={"w-full px-4 py-2 rounded-md text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                </Row>
                                {/* </div> */}
                                <Row xl="2">
                                    <CustomInput
                                        fieldLabel="Admin Username"
                                        fieldName={"Username"}
                                        placeholder="Username"
                                        error={errors.Username}
                                        control={control}
                                        type={"password"}
                                        classData={"w-full px-4 py-2 rounded-md  text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                      <CustomInput
                                        fieldLabel="Admin Password"
                                        fieldName={"password"}
                                        placeholder="Password"
                                        error={errors.password}
                                        control={control}
                                        type={"password"}
                                        classData={"w-full px-4 py-2 rounded-md  text-black placeholder-gray-400 mb-2 mt-1"}
                                    />
                                </Row>

                                <Row xl="2">
                                    <Col md="6">
                                        <label className="block form-label mt-1 mb-2">Logo</label>
                                        <input type="file" {...register("logo")} className="w-full border rounded-md p-2" />

                                        {errors.logo && <p className="text-red-500">{errors.logo.message}</p>}
                                    </Col>
                                    <Col md="6">
                                        <label className="block form-label mt-1 mb-2">Admin Image</label>
                                        <input type="file" {...register("adminImage")} className="w-full border rounded-md p-2" />

                                        {errors.adminImage && <p className="text-red-500">{errors.adminImage.message}</p>}
                                    </Col>
                                </Row>
                                {/* </div> */}
                                <Button
                                    type="submit"
                                    className="w-full bg-[#fff37a] text-black-800 py-2 rounded-md hover:[#f7e64f] transition duration-200 font-bold mt-2"
                                    onClick={handleSubmit(onSubmit)}
                                >
                                    Register
                                </Button>
                            </Form>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    )
}
export default OrgRegister;